import React, { createContext, useReducer, useContext } from "react";

// Estado inicial completo com todas as suas chaves
const initialState = {
  user: "",
  masterplan_id: "",
  userContext: "",
  aiContext: "",
  firstDraft: "",
  pains_options: [],
  goals_options: [],
  functions_options: [],
  selected_pains: [],
  selected_goals: [],
  selected_functions: [],
  suggested_name: "",
  process_context: "",
  ai_vision: "",
  outcomes: "",
  roadmap: "",
  isLoading: false,
  finalDraftReady: false,
  error: null,
};

const GlobalContext = createContext(initialState);

const toggleItemInArray = (array, item) => {
  const isSelected = array.includes(item);
  return isSelected ? array.filter((i) => i !== item) : [...array, item];
};

const globalReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_STATE":
      return { ...state, ...action.payload };

    case "HYDRATE_FROM_DB": {
    const p = action.payload || {};
    return { ...state, ...p, finalDraftReady: true };
    }

    case "SET_USER_NAME":
      return {
        ...state,
        user: (action.payload ?? "").trim(),
      };

    case "FIRST_DRAFT_RESPONSE": {
      const { masterplan_id, masterplan } = action.payload;
      return {
        ...state,
        isLoading: false,
        masterplan_id: masterplan_id,
        aiContext: masterplan.context,
        pains_options: masterplan.pains_options,
        goals_options: masterplan.goals_options,
        functions_options: masterplan.functions_options,
      };
    }

    case "TOGGLE_PAIN_SELECTION":
      return {
        ...state,
        selected_pains: toggleItemInArray(state.selected_pains, action.payload),
      };

    case "TOGGLE_GOAL_SELECTION":
      return {
        ...state,
        selected_goals: toggleItemInArray(state.selected_goals, action.payload),
      };

    case "TOGGLE_FUNCTION_SELECTION":
      return {
        ...state,
        selected_functions: toggleItemInArray(
          state.selected_functions,
          action.payload
        ),
      };

    case "FINAL_DRAFT_RESPONSE": {
      const { masterplan, suggested_name } = action.payload;
      const { final_draft } = masterplan;
      return {
        ...state,
        isLoading: false,
        suggested_name: suggested_name,
        process_context: final_draft.process_context,
        ai_vision: final_draft.ai_vision,
        features: final_draft.features,
        outcomes: final_draft.outcomes,
        roadmap: final_draft.roadmap,
        finalDraftReady: true, 
      };
    }

    case "RESET_STATE":
      return initialState;

    default:
      return state;
  }
};

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  return useContext(GlobalContext);
};
